import axios from '@/plugins/axios'

export function getAnnouncements(params = {}) {
  return axios.get('announcements', {
    params,
  })
}

export function editAnnouncement(id) {
  return axios.get(`announcements/${id}/edit`)
}

export function storeAnnouncement(data) {
  return axios.post('announcements', data)
}

export function updateAnnouncement(id, data) {
  return axios.put(`announcements/${id}`, data)
}
